/** Philippine peso formatters for KPI cards, axis labels, tooltips. */
const PESO = '₱';
/** Compact: ₱1.2K / ₱3.4M / ₱5.6B. Best for axis labels and KPI cards. */
export function formatPHPShort(v) {
    if (v === null || v === undefined || Number.isNaN(v))
        return '—';
    const abs = Math.abs(v);
    const sign = v < 0 ? '-' : '';
    if (abs >= 1e9)
        return `${sign}${PESO}${(abs / 1e9).toFixed(2)}B`;
    if (abs >= 1e6)
        return `${sign}${PESO}${(abs / 1e6).toFixed(2)}M`;
    if (abs >= 1e3)
        return `${sign}${PESO}${(abs / 1e3).toFixed(1)}K`;
    return `${sign}${PESO}${abs.toFixed(0)}`;
}
/** Full: ₱1,234,567. Best for tables and tooltips. */
export function formatPHPFull(v) {
    if (v === null || v === undefined || Number.isNaN(v))
        return '—';
    return `${PESO}${Math.round(v).toLocaleString('en-PH')}`;
}
/** Percent: 12.3%. */
export function formatPct(v, digits = 1) {
    if (v === null || v === undefined || Number.isNaN(v))
        return '—';
    return `${v.toFixed(digits)}%`;
}
/** Signed delta: +1.2K / -3.4K. */
export function formatPHPDelta(v) {
    if (v === null || v === undefined || Number.isNaN(v))
        return '—';
    const sign = v > 0 ? '+' : v < 0 ? '-' : '';
    return `${sign}${formatPHPShort(Math.abs(v)).replace('-', '')}`;
}
